module.exports = __webpack_public_path__ + "img/compass.14f577ba.png";